export enum BatchType {
  RISCO = 'RISCO',
  RESULTAS = 'RESUL'
}
